<template>
  <div class="px-[24px] h-screen flex flex-col justify-center">
    <div class="">
      <EnvelopeSuccessIcon class="mx-auto" />

      <StrongTitle class="mt-8">
        {{ $t('check_your_email') }}
      </StrongTitle>

      <div
        class="mt-5 text-center"
        v-html="$t('check_your_email_text', { email })"
      ></div>

      <BaseButton
        :disabled="loading"
        class="mt-5"
        @click="resend"
      >
        {{ $t('resend') }}
      </BaseButton>
    </div>
  </div>
</template>

<script setup>
import BaseButton from '@/components/buttons/BaseButton.vue'
import StrongTitle from '@/components/ui/StrongTitle.vue'
import EnvelopeSuccessIcon from '@/assets/icons/EnvelopeSuccessIcon.vue'
import { useRoute } from 'vue-router'
import { getPasswordResetLink } from '@/services/api/Auth'
import { ref } from 'vue'
import { sleep } from '@/services/auth/Auth.service'

const route = useRoute()
const email = route.query.email

const loading = ref(false)
// const goToSetPassword = () => router.push({name: ROUTE_NAMES.PASSWORD_RESET_NEW_PASSWORD})
const resend = async () => {
  loading.value = true
  await getPasswordResetLink(email)
  await sleep(3000)
  loading.value = false
}
</script>
